import React, { useState, useEffect, useRef } from 'react';
import { ShoppingBag } from 'lucide-react';
import { useGeo } from '../contexts/GeoContext';
import { useLocation } from 'react-router-dom';

const NAMES_BR = ['Lucas M.', 'Gabriel S.', 'Matheus O.', 'Pedro H.', 'Kaua R.', 'Vitor L.', 'Guilherme A.', 'Rafael C.', 'Enzo G.', 'Joao P.', 'Davi F.', 'Bruno T.', 'Felipe N.', 'Igor B.', 'Ryan S.', 'Caio D.', 'Thiago V.', 'Wesley M.', 'Eduardo R.', 'Nicolas F.'];
const NAMES_INTL = ['Alex M.', 'John D.', 'Carlos R.', 'Mike T.', 'Kevin S.', 'Daniel P.', 'Chris L.', 'Omar H.', 'Leo G.', 'Sam W.'];

const PURCHASES = [
  { product: 'PAINEL INTERNAL ANDROID', plan: 'Permanente' },
  { product: 'PAINEL INTERNAL ANDROID', plan: '1 Mes' },
  { product: 'PAINEL INTERNAL ANDROID', plan: '15 Dias' },
  { product: 'PAINEL INTERNAL IOS', plan: '1 Mes' },
  { product: 'PAINEL INTERNAL IOS', plan: 'Permanente' },
  { product: 'INTERNAL CORE EMULADOR', plan: '1 Mes' },
  { product: 'BYPASS 50 PLAYERS', plan: '15 Dias' },
  { product: 'AIMLESS MENU', plan: '1 Mes' },
  { product: 'AIMLESS MENU', plan: 'Permanente' },
];

const rand = (arr) => arr[Math.floor(Math.random() * arr.length)];

const SocialProof = () => {
  const { isBrazil } = useGeo();
  const { pathname } = useLocation();
  const [notif, setNotif] = useState(null);
  const [visible, setVisible] = useState(false);
  const timers = useRef([]);

  useEffect(() => {
    const schedule = (delay) => {
      const t = setTimeout(() => {
        const purchase = rand(PURCHASES);
        const mins = Math.floor(Math.random() * 12) + 1;
        setNotif({ name: rand(isBrazil ? NAMES_BR : NAMES_INTL), ...purchase, mins });
        setVisible(true);
        timers.current.push(setTimeout(() => setVisible(false), 6000));
        schedule(12000 + Math.random() * 13000);
      }, delay);
      timers.current.push(t);
    };
    schedule(7000);
    return () => timers.current.forEach(clearTimeout);
  }, [isBrazil]);

  if (!notif || pathname.startsWith('/admin') || pathname.startsWith('/prod-admin')) return null;

  return (
    <div
      className={`fixed bottom-20 md:bottom-6 left-3 md:left-6 z-[60] transition-all duration-500 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0 pointer-events-none'}`}
      data-testid="social-proof-notification"
    >
      <div className="flex items-center gap-3 bg-gray-900/90 backdrop-blur-xl border border-red-600/30 rounded-2xl pl-3 pr-4 py-3 shadow-2xl shadow-black/60 max-w-[300px] sm:max-w-[340px]">
        <div className="relative flex-shrink-0">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-red-600/30 to-red-900/20 border border-red-600/40 flex items-center justify-center">
            <ShoppingBag className="w-5 h-5 text-red-400" />
          </div>
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-gray-900 animate-pulse" />
        </div>
        <div className="min-w-0">
          <p className="text-white text-xs sm:text-sm font-bold leading-tight truncate">
            {notif.name} <span className="font-normal text-gray-300">{isBrazil ? 'comprou' : 'purchased'}</span>
          </p>
          <p className="text-red-400 text-[11px] sm:text-xs font-bold truncate">{notif.product} · {notif.plan}</p>
          <p className="text-gray-500 text-[10px] mt-0.5">{isBrazil ? `ha ${notif.mins} min` : `${notif.mins} min ago`} · <span className="text-green-500">✓ {isBrazil ? 'Verificado' : 'Verified'}</span></p>
        </div>
      </div>
    </div>
  );
};

export default SocialProof;
